import React, { useState, useEffect, useCallback } from "react";
import { useApi } from "../../components/api";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useAuthDataContext } from "../../components/auth-provider";
import { FaturaItensTable } from "./FaturaItensTable";
import { Fatura } from "./models";
import { RouteComponentProps, useHistory } from "react-router-dom";

interface GetFaturasResponse {
  anterior?: Fatura;
  atual?: Fatura;
  proxima?: Fatura;
  atualBarrasImg?: string;
}

export const FaturasPage = (props: RouteComponentProps) => {
  let faturaId: string | undefined = undefined;
  if (props.location.search) {
    let pars = props.location.search.split("id=");
    if (pars.length === 2) {
      faturaId = pars[1];
    }
  }

  const history = useHistory();

  const [loadingMessage, setLoadingMessage] = useState<string | undefined>(
    "Carregando dados...",
  );
  const [status, setStatus] = useState<GetFaturasResponse | undefined>(
    undefined,
  );

  const { api } = useApi("clientApp/");
  const { onLogout } = useAuthDataContext();

  const recarregar = useCallback(() => {
    const internalReload = async () => {
      const resp = await api.get<GetFaturasResponse>(
        "faturas" + (faturaId ? "?id=" + faturaId : ""),
      );
      setStatus(resp.data);
    };
    internalReload();
  }, [api, faturaId]);

  useEffect(() => {
    const load = async () => {
      setLoadingMessage("Carregando dados...");
      try {
        recarregar();
      } catch (error) {}
      setLoadingMessage(undefined);
    };

    load();
  }, [recarregar]);

  const handleNav = useCallback(
    (id) => {
      history.push("/faturas?id=" + id);
    },
    [history],
  );

  return (
    <div>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Grid item>
              {status?.anterior && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => handleNav(status?.anterior?.id)}
                >
                  {status?.anterior?.id}
                </Button>
              )}
            </Grid>
            <Grid item>
              {status?.atual && (
                <div>
                  <b>FATURA ATUAL: {status?.atual?.id}</b>
                </div>
              )}
            </Grid>
            <Grid item>
              {status?.proxima && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => handleNav(status?.proxima?.id)}
                >
                  {status?.proxima?.id}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            spacing={0}
            justifyContent="center"
            style={{ padding: "18px 0px" }}
          >
            {loadingMessage ? (
              <Grid item xs={12}>
                <p>Aguarde, carregando dados...</p>
                <LinearProgress color="secondary" />
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Grid container spacing={4} justifyContent="center">
                  {status?.atual && (
                    <div>
                      <p>Numero: {status.atual.id}</p>
                      <p>Total: {status.atual.total}</p>
                      <p>
                        Abertura:{" "}
                        {new Date(status.atual.abertura).toDateString()}
                      </p>
                      <p>
                        Fechamento:{" "}
                        {new Date(status.atual.fechamento).toDateString()}
                      </p>
                      <p>
                        Vencimento:{" "}
                        {new Date(status.atual.vencimento).toDateString()}
                      </p>

                      <FaturaItensTable rows={status.atual.itens} />

                      {status.atualBarrasImg && (
                        <Grid container justifyContent="center">
                          <div className="center">
                            <p>Pague pelo código de barras:</p>
                            <img
                              src={status.atualBarrasImg}
                              alt="Codigo barras"
                            />
                            <p>{status.atual.linhaDigitavel}</p>
                            <br />
                            <br />
                          </div>
                        </Grid>
                      )}
                    </div>
                  )}
                </Grid>
              </Grid>
            )}
            <Grid item>
              <Button color="primary" variant="contained" onClick={onLogout}>
                Sair
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
